// extracted by mini-css-extract-plugin
export var container = "_jd-0";
export var segment = "_jd-2";
export var segmentActive = "_jd-3";
export var track = "_jd-1";